// extracted by mini-css-extract-plugin
module.exports = {"root":"_1WNhH","text":"_2422t"};